package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class Tags(
    val id: String,
    tag: String = ""
) {
    var tag by mutableStateOf(tag)
}
